// extracted by mini-css-extract-plugin
export default {"container":"declaration_container__67ukH","declare":"declaration_declare__HqeXn"};